import React from "react";
import { URLImgFront } from '../../../../config/URLDB';

class Premios extends React.Component {

    render() {
        return (
            <div className="bg-white">
                <div data-aos="fade-left" data-aos-delay="1000">
                    <div className="d-flex justify-content-center flex-column align-items-center">
                        <picture>
                            <source srcSet={`${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/PremiosMovil.webp`} media="(max-width: 768px)" />
                            <source srcSet={`${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/PremiosMovil.webp`} media="(max-width: 1025px )" />
                            <img className="img-fluid" style={{ width: 'auto', height: 'auto', display: 'block', touchAction: 'manipulation' }} src={`${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/Premios.webp`} alt="Coopenautas" />
                        </picture>
                    </div>
                </div>
            </div>
        );
    }
}

export default Premios;